"use strict";
/**
 * API helper functions for PDF export
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportApi = void 0;
const apiClient_1 = require("./apiClient");
exports.exportApi = {
    /**
     * Export an existing student degree plan as PDF.
     *
     * Sends the full serialized plan payload to /degreePlan/export via the
     * auth-aware apiClient (adds the Authorization header automatically).
     * Matches the Angular serializeDegreePlanForStudentExport + postBlob pattern.
     *
     * @param degreePlan  The loaded degree plan (provides cohort/org/profile/program context)
     * @param termPlans   Current term-plan state (may differ from degreePlan.terms if user edited)
     * @param graduationDate  Current graduation date as YYYY-MM-DD string (from UI state)
     */
    exportDegreePlanPdf: (degreePlan, termPlans, graduationDate) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        const tenantId = degreePlan.tenantId || degreePlan.organization.tenantId;
        const payload = {
            studentIds: [],
            cohortDto: {
                cohort: {
                    organizationId: degreePlan.organization.id,
                    academicProgramId: (_b = (_a = degreePlan.academicProgram) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '',
                    tenantId,
                    // Default to empty string so these keys are always present in the payload
                    program: (_c = degreePlan.cohort.program) !== null && _c !== void 0 ? _c : '',
                    track: (_d = degreePlan.cohort.track) !== null && _d !== void 0 ? _d : '',
                    specialization: (_e = degreePlan.cohort.specialization) !== null && _e !== void 0 ? _e : '',
                    cohortId: degreePlan.cohort.id,
                },
            },
            degreePlanDto: {
                degreePlan: {
                    type: degreePlan.type,
                    academicProgramId: (_g = (_f = degreePlan.academicProgram) === null || _f === void 0 ? void 0 : _f.id) !== null && _g !== void 0 ? _g : '',
                    // Backend expects a millisecond Unix timestamp, not an ISO string
                    graduationDate: graduationDate
                        ? new Date(graduationDate + 'T00:00:00').getTime()
                        : ((_j = (_h = degreePlan.graduationDate) === null || _h === void 0 ? void 0 : _h.getTime()) !== null && _j !== void 0 ? _j : undefined),
                    tenantId,
                    organizationId: degreePlan.organization.id,
                    profileId: (_l = (_k = degreePlan.profile) === null || _k === void 0 ? void 0 : _k.id) !== null && _l !== void 0 ? _l : '',
                    studentProgramId: degreePlan.studentProgramId,
                    // Backend PdfExportServiceImpl calls audit.getDateModified() unconditionally.
                    // A null audit causes a NullPointerException that truncates the PDF mid-stream
                    // while the HTTP 200 headers have already been sent.
                    // Use real audit data when available; fall back to current time so the field
                    // is never null and the backend can format (or skip) the date safely.
                    audit: (_m = degreePlan.audit) !== null && _m !== void 0 ? _m : { dateModified: Date.now() },
                },
                degreePlanTermDtos: termPlans.map((tp) => ({
                    degreePlanTerm: {
                        termId: tp.term.id,
                        position: tp.position,
                    },
                    degreePlanTermCourseDtos: tp.courses.map((cp) => ({
                        degreePlanTermCourse: {
                            courseId: cp.course.id,
                        },
                    })),
                })),
            },
        };
        return apiClient_1.apiClient.postBlob('/degreePlan/export', payload);
    },
    /**
     * Export a snap (cohort apply) preview as PDF.
     * Sends the full snap payload (studentIds may be empty) to /degreePlan/export.
     * Matches Angular's exportPDF → serializeDegreePlanForStudentExport pattern.
     */
    exportSnapPreviewPdf: (snapPayload) => apiClient_1.apiClient.postBlob('/degreePlan/export', snapPayload),
};
